// Lightweight i18n + currency context.
import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import { translations } from "../i18n/translations";

const I18nContext = createContext(null);

const FX_FROM_USD = { USD: 1.0, EUR: 0.92, RON: 4.58 };
const CURRENCY_SYMBOL = { USD: "$", EUR: "€", RON: "lei" };

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("eduhu_lang") || "en");
  const [currency, setCurrency] = useState(
    () => localStorage.getItem("eduhu_currency") || "USD",
  );

  useEffect(() => localStorage.setItem("eduhu_lang", lang), [lang]);
  useEffect(() => localStorage.setItem("eduhu_currency", currency), [currency]);

  const t = useMemo(() => {
    const dict = translations[lang] || translations.en;
    return (key) => dict[key] ?? translations.en[key] ?? key;
  }, [lang]);

  const formatPrice = (usd) => {
    const rate = FX_FROM_USD[currency] ?? 1;
    const amount = Number(usd) * rate;
    const symbol = CURRENCY_SYMBOL[currency] || "$";
    if (currency === "RON") return `${amount.toFixed(0)} ${symbol}`;
    return `${symbol}${amount.toFixed(0)}`;
  };

  const value = useMemo(
    () => ({ lang, setLang, currency, setCurrency, t, formatPrice }),
    [lang, currency, t],
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n outside provider");
  return ctx;
};
